// Webpack's compatibility - check if we're in browser environment
const isBrowser = typeof window !== 'undefined';
const safeWindow = isBrowser ? window : {};
const safeLocation = isBrowser ? (typeof location !== 'undefined' ? location : { href: '' }) : { href: '' };
const safeNavigator = isBrowser ? (typeof navigator !== 'undefined' ? navigator : { userAgent: '' }) : { userAgent: '' };

const getQueryString = function () {
    let key : boolean | string = false,
        res : any = {},
        itm = null;
    // get the query string without the ?
    const arr = safeLocation.href.split("?");
    const qs = arr[1];
    // check for the key as an argument
    if (arguments.length > 0 && arguments[0].length > 1)
        key = arguments[0];
    // make a regex pattern to grab key/value
    const pattern = /([^&=]+)=([^&]*)/g;
    // loop the items in the query string, either
    // find a match to the argument, or build an object
    // with key/value pairs
    while (itm = pattern.exec(qs)) {
        if (key !== false && decodeURIComponent(itm[1]) === key)
            return decodeURIComponent(itm[2]);
        else if (key === false)
            res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
    }
    return key === false ? res : null;
}


const ua = safeNavigator.userAgent;
const msie = ua.indexOf("MSIE ");
const obj = { ecvInvite: null }; // this is for assigning ecvInvite to window object as value type instead of refrence type
let url: URL | null = null;

if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    const searchParams = getQueryString();
    obj.ecvInvite = searchParams.eI;
} else {
     url = new URL(window.location.href.replace('#', '_hash_'));
    obj.ecvInvite = url.searchParams.get("eI");
}
//If it is open from parent window
if(window.opener != null && !window.opener.closed){
    //if the url contains code.
    if(url && url.searchParams.get('code')){
        let dataTosend ={
            action : "integrateZoom",
            code : url.searchParams.get('code')
        }
        //send the code using the post message to the parent window.
        window.opener.postMessage(dataTosend , window.opener.location.href);
        window.close();
    }

    //if the url contains access_token and refresh_token.
    if(url && url.searchParams.get('access_token') && url.searchParams.get('refresh_token')){
        let dataTosend ={
            action : "integrateCalendar",
            accessToken : url.searchParams.get('access_token'),
            refreshToken : url.searchParams.get('refresh_token')
        }
        //send the code using the post message to the parent window.
        window.opener.postMessage(dataTosend , window.opener.location.href);
        window.close();
    }
}

if (!!obj.ecvInvite) {
    window.sessionStorage["ecvInvite"] = obj.ecvInvite;
}
